import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=f1f79c64&scoped=true&"
import script from "./Complaint.vue?vue&type=script&lang=js&"
export * from "./Complaint.vue?vue&type=script&lang=js&"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=f1f79c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f79c64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f79c64')) {
      api.createRecord('f1f79c64', component.options)
    } else {
      api.reload('f1f79c64', component.options)
    }
    module.hot.accept("./Complaint.vue?vue&type=template&id=f1f79c64&scoped=true&", function () {
      api.rerender('f1f79c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/Complaint.vue"
export default component.exports